import { DataSource, Label, Layout, Tab } from "@mcleod/components";
import { Collection } from "@mcleod/core";
import { UIDesigner } from "../UIDesigner";
import { DesignerDataSourcePanel } from "./DesignerDataSourcePanel";

export class DesignerTab extends Tab {
  designer: UIDesigner;
  path: string;
  private _baseVersion: boolean;
  lastSelectedDataSource: DataSource;
  _modified: boolean;
  dataSources: Collection<DataSource> = {};
  designerPanel: Layout;
  dataSourcePanel: DesignerDataSourcePanel;

  constructor(designer: UIDesigner, path?: string, props?) {
    super({ fillHeight: true, fillRow: true, minHeight: 80, closeable: true, ...props })
    this.designer = designer;
    this.path = path;
    this.designerPanel = new Layout({ 
      fillHeight: true, 
      fillRow: true, 
      _designer: designer, 
      scrollY: true, 
      allowDecoratorOverride: true, 
      applyFieldLevelPermissions: false, 
      applyFieldLevelLicensing: false
    });
    this.dataSourcePanel = new DesignerDataSourcePanel(this);
    this.add(this.designerPanel);
    this.add(this.dataSourcePanel);
  }

  get baseVersion(): boolean {
    return this._baseVersion;
  }

  set baseVersion(value: boolean) {
    this._baseVersion = value;
    this.imageName = value === false ? "formPencil" : null;
  }

  get modified(): boolean {
    return this._modified;
  }

  set modified(value: boolean) {
    if (this._modified === value)
      return;
      this._modified = value;
    if (value)
      this.caption = this.caption + " *";
    else if (this.caption.endsWith(" *"))
      this.caption = this.caption.substring(0, this.caption.length - 2);
  }

  override createHeading() {
    super.createHeading();
    this.heading.id = "designerTabHeading";
  }

  dataSourceIdUpdated(dataSource: DataSource, oldId: string, newId: string): void {
    delete this.dataSources[oldId];
    this.dataSources[newId] = dataSource;
    const children = this.dataSourcePanel.targetPanel.getRecursiveChildren();
    for (let j = 0; j < children.length; j++) {
      const currentChild = children[j];
      if (currentChild instanceof Label && currentChild.caption === oldId)
        currentChild.caption = newId;
    }
  }
}
